import React from 'react';

import './style.css';

const Lashes = () => (
  <svg className="Lashes" viewBox="0 0 362.49 52.83">
    <g id="Ebene_2">
      <g id="Lashes">
        <g id="Lashes-2">
          <path d="M33.3,28.44l1.47,5.37-.2.06C23.07,37,11.55,31.47,8.83,21.5a16.26,16.26,0,0,1-.55-3.37C11.93,26.79,22.63,31.35,33.3,28.44Z"/>
          <path d="M27,26.7l3.18,4.57-.17.12c-9.78,6.81-22.48,5.44-28.39-3a16.26,16.26,0,0,1-1.65-3C6.34,32.3,18,33,27,26.7Z"/>
          <path d="M329.53,12.26l-1.05,5.46.2,0c11.7,2.25,22.76-4.15,24.71-14.3a16.26,16.26,0,0,0,.29-3.4C350.71,9,340.39,14.34,329.53,12.26Z"/>
          <path d="M335.65,10l-2.82,4.8L333,15c10.27,6,22.84,3.7,28.07-5.2a16.26,16.26,0,0,0,1.41-3.11C356.71,14,345.18,15.65,335.65,10Z"/>
        </g>
        <circle cx="33.05" cy="35.22" r="17.61"/>
        <circle cx="37.5" cy="26.06" fill="#fff" r="3.5"/>
        <circle cx="43.28" cy="31.84" fill="#fff" r="2.3"/>
        <circle cx="330.67" cy="17.61" r="17.61"/>
        <circle cx="335.11" cy="8.45" fill="#fff" r="3.5"/>
        <circle cx="340.91" cy="14.23" fill="#fff" r="2.3"/>
      </g>
    </g>
  </svg>
);

export default Lashes;


// WEBPACK FOOTER //
// ./src/game/components/makeUp/Lashes/index.js